<template>
  <Temporary />
</template>

<script>
import Temporary from "@/views/dashboard/settings/profile/Temporary.vue"

export default {
  name: "ShareSpaceHome",
  components: {
    Temporary
  },

  created() {
    //later on check which objects are shared and redirect to first available object
    if (this.$store.state.auth.user.organization) {
      this.$router.replace(`/share-space/${this.$store.state.organization.id}/plans`)
    }
  }
}
</script>
